function checkProtocolLink(linkData, nodeData, key) {
  const links = linkData;
  const nodes = nodeData;
  let linkItems = [];
  let nodeItems = [];
  let nodeInfo = {};

  function checkLink(checkKey, beforeLink) {
    for(let link of links) {
      if(link.to === checkKey && link.from != beforeLink.to){
        linkItems.push(link);
        checkLink(link.from, link);
      }
    }
  }
  function makeNodeInfo() {
    let first;
    nodeItems = (nodes.filter( node=> key === node.key ));
    if(!nodeItems || nodeItems.length == 0) return;
    first = nodeItems[0];
    nodeInfo[first.category] = {};
    nodeInfo[first.category][first.text] = [first];
    for(let link of linkItems) {
      for(let node of nodes) {
        if(link.from === node.key) {
          nodeItems.push(node);
          if(!nodeInfo[node.category]) nodeInfo[node.category] = {};
          if(!nodeInfo[node.category][node.text]) nodeInfo[node.category][node.text] = [node];
          else nodeInfo[node.category][node.text].push(node);
          break;
        }
      }
    }
  }
  for(let link of links) {
    if(link.to === key ){
      linkItems.push(link);
      checkLink(link.from, link);
      break;
    }
  }
  if(links.length !== 0) makeNodeInfo();
  
  return {
    links: linkItems,
    nodes: nodeItems,
    nodeInfo,
  };
}

function makeNodeTotalCategory(nodeInfo, protocolKey, nodeTotalCategory={}) {
  let categorys = Object.entries(nodeInfo);
  for(let [category, items] of categorys){
    if(!nodeTotalCategory[category]) continue;
    let categoryItem = nodeTotalCategory[category];

    for(let [title, node] of Object.entries(items)){
      if(!categoryItem.items[title]) {
        categoryItem.items[title] = [protocolKey];
      }else {
        categoryItem.items[title].push(protocolKey);
      }
    }
    nodeTotalCategory[category].cnt = Object.keys(categoryItem.items).length;
  }
  return nodeTotalCategory;
}

function protocolsInLink(protocols, linkDatas, nodeDatas) {
  const nodeLinkInfo = [];
  const protocolInfo = [];
  // const nodeTotalCategory = {
  //   ANALYSIS: {cnt:0, items:{}},
  //   EQUIPMENT: {cnt:0, items:{}},
  //   MATERIAL: {cnt:0, items:{}},
  //   MEASUREMENT: {cnt:0, items:{}},
  // }
  for(let protocol of protocols) {
    let {links, nodes, nodeInfo} = checkProtocolLink(linkDatas, nodeDatas, protocol.innerKeyOfProtocol || protocol.key);
    let categorys = [];

    // makeNodeTotalCategory(nodeInfo, protocol.keyOfProtocol, nodeTotalCategory)

    for(let [key, value] of Object.entries(nodeInfo)) {
      categorys.push({type: key, items: Object.keys(value)})
    } 
    protocol.categorys = categorys;
    nodeLinkInfo.push({ links, nodes, nodeInfo});
    protocolInfo.push({
      protocol, links, nodes, nodeInfo
    })
  }
  // return {
  //   nodeLinkInfo, protocolInfo, 
  //   // nodeTotalCategory
  // }
  return protocolInfo
}

export {
  checkProtocolLink, makeNodeTotalCategory, protocolsInLink
}